import { render, staticRenderFns } from "./porposalHistory.vue?vue&type=template&id=2d8b8930&"
import script from "./porposalHistory.vue?vue&type=script&lang=ts&"
export * from "./porposalHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports